export enum ManualLookupComponentTypes {
  make = 'make',
  model = 'model',
  fuelType = 'fuelType',
  yearOrRegistrationLetter = 'yearOrRegistrationLetter',
  colour = 'colour',
  metallicPaint = 'metallicPaint',
  derivative = 'derivative'
}
